import type { TemplateDependencyValidationError } from '@festina/configuration-general-types/configuration'
import type { Optional } from '@festina-life/core'

import type { TemplateReferenceValueSetupField } from '../../types/templateModel'
import type { ValidationErrorWithLocation } from '../../uiModels/errors/types'
import { TemplateReferenceValuesTable } from './TemplateReferenceValuesTable'
import { TemplateReferenceValueViewer } from './TemplateReferenceValueViewer'

type Props = {
  field: TemplateReferenceValueSetupField
  isExpanded?: boolean
  errors?: Optional<
    ValidationErrorWithLocation<TemplateDependencyValidationError>[]
  >
}

export const TemplateReferenceFieldValue = ({
  field,
  isExpanded,
  errors,
}: Props) =>
  isExpanded ? (
    <TemplateReferenceValuesTable
      field={field}
      isExpanded={isExpanded}
      errors={errors}
    />
  ) : (
    <TemplateReferenceValueViewer field={field} isExpanded={isExpanded} />
  )
